var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoctorHat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Health/Doctor Hat",
    clipPath: "url(#clip0_1747_10446)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.71442 9.71429C5.71442 9.3987 5.97026 9.14286 6.28585 9.14286H9.71442C10.03 9.14286 10.2858 9.3987 10.2858 9.71429C10.2858 10.0299 10.03 10.2857 9.71442 10.2857H6.28585C5.97026 10.2857 5.71442 10.0299 5.71442 9.71429Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00013 7.42857C8.31573 7.42857 8.57156 7.68441 8.57156 8V11.4286C8.57156 11.7442 8.31573 12 8.00013 12C7.68454 12 7.42871 11.7442 7.42871 11.4286V8C7.42871 7.68441 7.68454 7.42857 8.00013 7.42857Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.40024 5.74057C5.34755 4.18577 10.6527 4.18577 15.6 5.74057C15.8955 5.83345 16.0632 6.14486 15.9781 6.4427L13.6924 14.4427C13.6223 14.688 13.3981 14.8571 13.143 14.8571H2.85728C2.60215 14.8571 2.37792 14.688 2.30783 14.4427L0.0221205 6.4427C-0.0629772 6.14486 0.104729 5.83345 0.40024 5.74057ZM1.27569 6.67012L3.28831 13.7143H12.712L14.7246 6.67012C10.3318 5.39973 5.6685 5.39973 1.27569 6.67012Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.42903 1.14286H10.5255C10.8987 1.12891 11.2664 1.23723 11.5726 1.45155C11.8748 1.66307 12.1005 1.96626 12.2165 2.31583L13.5445 5.49397C13.6662 5.78516 13.5288 6.11986 13.2376 6.24154C12.9464 6.36321 12.6117 6.22579 12.49 5.9346L11.1529 2.7346C11.1461 2.71839 11.1401 2.70188 11.1348 2.68512C11.0971 2.56471 11.0206 2.46018 10.9172 2.38782C10.8139 2.31546 10.6895 2.27935 10.5634 2.28512C10.5547 2.28552 10.546 2.28572 10.5373 2.28572H5.41728C5.40856 2.28572 5.39985 2.28552 5.39114 2.28512C5.2651 2.27935 5.14069 2.31546 5.03732 2.38782C4.93395 2.46017 4.85744 2.56471 4.81972 2.68512C4.81516 2.69966 4.81003 2.71401 4.80432 2.72814L3.51289 5.92814C3.39479 6.2208 3.06179 6.3623 2.76914 6.24419C2.47648 6.12608 2.33498 5.79309 2.45309 5.50043L3.73682 2.31949C3.85251 1.96837 4.0787 1.66381 4.38193 1.45155C4.68811 1.23723 5.05582 1.12891 5.42903 1.14286Z",
    fill: "currentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1747_10446"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorHat);
export default __webpack_public_path__ + "static/media/doctor-hat.2d9f4448a10595b81e30027b0838045c.svg";
export { ForwardRef as ReactComponent };